import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _extends from "@babel/runtime/helpers/esm/extends";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { IconArrowDown, IconArrowUp } from '@sfx/icons';
import { isEqual } from 'lodash';
import React from 'react';
import PaginationSimple from "../../Pagination";
import SFxFilterDropdown from './SubComponents/SFxFilterDropdown';
var prefix = 'sfx-react-ui';

var withSFxFilter = function withSFxFilter(WrappedComponent) {
  var _class, _temp;

  return _temp = _class = /*#__PURE__*/function (_React$Component) {
    _inherits(Wrapper, _React$Component);

    var _super = _createSuper(Wrapper);

    function Wrapper(props) {
      var _this;

      _classCallCheck(this, Wrapper);

      _this = _super.call(this, props);

      _defineProperty(_assertThisInitialized(_this), "wrapDom", void 0);

      _defineProperty(_assertThisInitialized(_this), "selectTable", void 0);

      _defineProperty(_assertThisInitialized(_this), "headerClick", function (e, id, disableSort) {
        e.stopPropagation();
        if (disableSort) return;
        var sorted = _this.state.sorted;
        var desc = false;

        if (Array.isArray(sorted) && sorted.length > 0 && sorted[0].id === id) {
          desc = !sorted[0].desc;
        }

        if (id) _this.setSorted(id, desc);
      });

      _defineProperty(_assertThisInitialized(_this), "setSorted", function (id, desc) {
        var sorted = [{
          id: id,
          desc: desc
        }];
        var onSortedChange = _this.props.onSortedChange;

        _this.setState({
          sorted: sorted
        }, function () {
          onSortedChange && onSortedChange(sorted);
        });
      });

      _defineProperty(_assertThisInitialized(_this), "hasSorted", function (id) {
        var sorted = _this.state.sorted;
        var sortedDesc = null;

        if (Array.isArray(sorted) && sorted.length && sorted[0].id === id && sorted[0].desc !== null) {
          sortedDesc = sorted[0].desc;
        }

        return sortedDesc;
      });

      _defineProperty(_assertThisInitialized(_this), "setHeader", function (_ref) {
        var Header = _ref.Header,
            headerTooltip = _ref.headerTooltip,
            id = _ref.id,
            _ref$isFilterable = _ref.isFilterable,
            isFilterable = _ref$isFilterable === void 0 ? false : _ref$isFilterable,
            _ref$isSortable = _ref.isSortable,
            isSortable = _ref$isSortable === void 0 ? false : _ref$isSortable,
            _ref$disableDropdownS = _ref.disableDropdownSort,
            disableDropdownSort = _ref$disableDropdownS === void 0 ? false : _ref$disableDropdownS,
            _ref$disableHeaderSor = _ref.disableHeaderSort,
            disableHeaderSort = _ref$disableHeaderSor === void 0 ? false : _ref$disableHeaderSor,
            showEditIcon = _ref.showEditIcon,
            Sorter = _ref.Sorter,
            Filter = _ref.Filter,
            _ref$relatedIds = _ref.relatedIds,
            relatedIds = _ref$relatedIds === void 0 ? [] : _ref$relatedIds,
            sortTextAsc = _ref.sortTextAsc,
            sortTextDesc = _ref.sortTextDesc;
        var sorted = _this.state.sorted;
        var sorterId = '';

        if (sorted.length) {
          var validSorter = sorted.find(function (item) {
            return item.desc !== null;
          });

          if (validSorter) {
            sorterId = validSorter.id;
          }
        }

        var showSorterIndicator = Sorter && relatedIds && sorterId && relatedIds.includes(sorterId); // if currentColumnSorted is null, it means this column is not sorted
        // else if currentColumnSorted is true, it means this column is sorted in descending order
        // else if currentColumnSorted is false, it means this column is sorted in ascending order

        var currentColumnSorted = _this.hasSorted(id);

        var disableClickHeaderSort = disableHeaderSort || !!Sorter || !isSortable;
        return /*#__PURE__*/React.createElement(React.Fragment, null, _this.state.currentResizeId && _this.state.currentResizeId === id ? /*#__PURE__*/React.createElement("div", {
          className: 'resizeMovingHeaderBar'
        }) : '', /*#__PURE__*/React.createElement("div", {
          className: "d-flex justify-content-between ".concat(prefix, "-headerBox"),
          onClick: function onClick(e) {
            return _this.headerClick(e, id, disableClickHeaderSort);
          }
        }, /*#__PURE__*/React.createElement("div", {
          className: "d-flex header"
        }, /*#__PURE__*/React.createElement("div", {
          className: "flex-shrink-1 headerText",
          title: headerTooltip !== undefined ? headerTooltip : Header
        }, Header), /*#__PURE__*/React.createElement(SFxFilterDropdown, _extends({}, _this.props, _this.state, {
          id: id,
          columns: _this.props.columns,
          sorted: _this.state.sorted,
          data: [1] // a hack way to show the dropdown icon when the search result is empty
          ,
          filterable: isFilterable,
          Sorter: Sorter,
          Filter: Filter,
          sortTextAsc: sortTextAsc,
          sortTextDesc: sortTextDesc,
          relatedIds: relatedIds,
          sortable: isSortable && !disableDropdownSort,
          setSorted: _this.setSorted,
          onFilter: _this.props.onSearch
        })), isSortable && !(disableDropdownSort && disableHeaderSort) && /*#__PURE__*/React.createElement("div", {
          className: "sort-indicator ".concat(currentColumnSorted !== null || showSorterIndicator ? sorterId : '')
        }, currentColumnSorted !== null && /*#__PURE__*/React.createElement(React.Fragment, null, currentColumnSorted ? /*#__PURE__*/React.createElement(IconArrowDown, {
          className: "arrowIcon"
        }) : /*#__PURE__*/React.createElement(IconArrowUp, {
          className: "arrowIcon"
        })), !currentColumnSorted && showSorterIndicator && /*#__PURE__*/React.createElement(React.Fragment, null, _this.state.sorted[0].desc ? /*#__PURE__*/React.createElement(IconArrowDown, {
          className: "arrowIcon"
        }) : /*#__PURE__*/React.createElement(IconArrowUp, {
          className: "arrowIcon"
        })))), showEditIcon && /*#__PURE__*/React.createElement("img", {
          alt: "edit icon",
          className: "editIcon",
          onClick: _this.props.onEditColumn,
          src: "./images/icons/columnsEdit.svg"
        })));
      });

      _defineProperty(_assertThisInitialized(_this), "onResizedChange", function (newResized, event) {
        if (newResized && newResized.length > 0) {
          // this.props.onResizedChange && this.props.onResizedChange(newResized, event);
          if (_this.props.onResizedChange) {
            _this.props.onResizedChange(newResized, event);
          }

          var id = newResized[newResized.length - 1].id;

          if (!(_this.state.currentResizeId && _this.state.currentResizeId === id)) {
            _this.setState({
              currentResizeId: id
            }); //register resize mouseup event


            document.addEventListener('mouseup', _this.resizeColumnEnd);
          }

          return {};
        }
      });

      _defineProperty(_assertThisInitialized(_this), "resizeColumnEnd", function () {
        _this.setState({
          currentResizeId: undefined
        });

        document.removeEventListener('mouseup', _this.resizeColumnEnd);
      });

      _defineProperty(_assertThisInitialized(_this), "onPageChange", function (page) {
        return _this.props.onPageChange && _this.props.onPageChange(page - 1);
      });

      _defineProperty(_assertThisInitialized(_this), "getTrProps", function (state, rowInfo, column) {
        var defaultStyle = {
          minWidth: state.rowMinWidth
        };
        var getTrProps = _this.props.getTrProps;
        var returnObj = {};

        if (getTrProps) {
          returnObj = getTrProps(state, rowInfo, column);
          returnObj.style = _objectSpread(_objectSpread({}, returnObj.style), defaultStyle);
        } else {
          returnObj.style = defaultStyle;
        }

        return returnObj;
      });

      _defineProperty(_assertThisInitialized(_this), "getTheadTrProps", function (state, rowInfo, column) {
        var defaultStyle = {
          minWidth: state.rowMinWidth
        };
        var getTheadTrProps = _this.props.getTheadTrProps;
        var returnObj = {};

        if (getTheadTrProps) {
          returnObj = getTheadTrProps(state, rowInfo, column);
          returnObj.style = _objectSpread(_objectSpread({}, returnObj.style), defaultStyle);
        } else {
          returnObj.style = defaultStyle;
        }

        return returnObj;
      });

      _this.state = {
        sorted: _this.props.sorted || [],
        filtered: _this.props.filtered,
        currentResizeId: undefined
      };
      _this.wrapDom = null;
      return _this;
    }

    _createClass(Wrapper, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        // As we only want the scroll on rt-tbody, we set head overflow hidden. Then we want to set thead's scrollLeft always the same as tbody.
        var theadDoms = this.wrapDom.getElementsByClassName("rt-thead");
        var tbodyDom = this.wrapDom.getElementsByClassName("rt-tbody")[0];
        tbodyDom.addEventListener("scroll", function () {
          for (var i = 0; i < theadDoms.length; i++) {
            theadDoms.item(i).scrollLeft = tbodyDom.scrollLeft;
          }
        });
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        var _this$props = this.props,
            filtered = _this$props.filtered,
            sorted = _this$props.sorted;

        if (!isEqual(prevProps.filtered, filtered)) {
          this.setState({
            filtered: filtered ? filtered : []
          });
        }

        if (sorted) {
          var sort = sorted.find(function (s) {
            return s.desc !== null;
          });
          var currentSort = this.state.sorted[0];

          if (!isEqual(sort, currentSort)) {
            this.setState({
              sorted: sort ? [_objectSpread({}, sort)] : []
            });
          }
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;

        // ... and renders the wrapped component with the fresh data!
        // Notice that we pass through any additional props
        var columns = this.props.columns.map(function (column) {
          if (column.id !== "_selector") {
            // skips the 'selectAll' item during 'withSelect' hoc
            return _objectSpread(_objectSpread({}, column), {}, {
              className: _this2.state.currentResizeId && _this2.state.currentResizeId === column.id ? "".concat(column.className ? column.className : '', " cellBorderRight") : "".concat(column.className ? column.className : ''),
              Header: _this2.setHeader(column)
            });
          }

          return _objectSpread({}, column);
        });

        var _this$props2 = this.props,
            manual = _this$props2.manual,
            showPagination = _this$props2.showPagination,
            isSortedOutside = _this$props2.isSortedOutside,
            data = _this$props2.data,
            page = _this$props2.page,
            pageSize = _this$props2.pageSize,
            total = _this$props2.total,
            onPageSizeChange = _this$props2.onPageSizeChange,
            restProps = _objectWithoutProperties(_this$props2, ["manual", "showPagination", "isSortedOutside", "data", "page", "pageSize", "total", "onPageSizeChange"]); // const { expandReset } = this.state
        // if props `total` is provided, TableView will not contain pagination logic, the props `pageSize` whose value is data.length will be passed to WrappedComponent, which is ReactTable in fact.
        // if props `total` is not provided, TableView assume that the data you provided is full dose, and you can provide props `page` and `pageSize` so that Table can initialize the pagination.


        var paginationParam = manual || showPagination === false || total ? {
          pageSize: data.length
        } : {
          page: page,
          pageSize: pageSize
        };
        var current = Number(page) + 1;
        return /*#__PURE__*/React.createElement("div", {
          className: "rt-wrap",
          ref: function ref(r) {
            _this2.wrapDom = r;
          }
        }, /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, restProps, {
          columns: columns,
          data: data,
          ref: function ref(r) {
            _this2.selectTable = r;
          },
          sortable: false,
          filterable: false
        }, paginationParam, {
          // Table's inner sort status need to be cleared if sort from outside(because props.data has already been sorted and sort arrow is controlled by func<setHeader>)
          sorted: manual || isSortedOutside ? [] : this.state.sorted,
          filtered: manual ? [] : this.state.filtered,
          onResizedChange: this.onResizedChange,
          showPagination: showPagination,
          getTrProps: this.getTrProps,
          getTheadTrProps: this.getTheadTrProps,
          PaginationComponent: function PaginationComponent(props) {
            return /*#__PURE__*/React.createElement(PaginationSimple, _extends({}, restProps, {
              current: current,
              pageSize: pageSize,
              total: total || props.sortedData.length,
              onChange: _this2.onPageChange,
              onChangeResultsPerPage: onPageSizeChange
            }));
          }
        })));
      }
    }]);

    return Wrapper;
  }(React.Component), _defineProperty(_class, "defaultProps", {
    filtered: [],
    columns: [],
    manual: false,
    defaultFilterMethod: defaultFilterMethod,
    getTableProps: getTableProps,
    getTheadProps: getTheadProps,
    paginationConfig: {
      ShowResultPerPage: true,
      ShowResults: true
    }
  }), _temp;
};

function defaultFilterMethod(filter, row) {
  return String(row[filter.id]).trim().toLowerCase().includes(String(filter.value).trim().toLowerCase());
}

function getTableProps(state) {
  var height = calculateHeight(state);

  if (!height) {
    return {};
  }

  return {
    style: {
      minHeight: height + 30
    }
  };
}

function getTheadProps(state) {
  var height = calculateHeight(state);

  if (!height) {
    return {};
  }

  return {
    style: {
      marginBottom: -height,
      paddingBottom: height
    }
  };
}

function calculateHeight(state) {
  var height = 0;

  if (state.columns.some(function (item) {
    return item.isFilterable && item.isSortable;
  })) {
    height = 150;
  } else if (state.columns.some(function (item) {
    return item.isSortable;
  })) {
    height = 120;
  } else if (state.columns.some(function (item) {
    return item.isFilterable;
  })) {
    height = 50;
  }

  return height;
}

export default withSFxFilter;